export const API_END_POINT = window?.['__env']?.['apiUrl'];
export const VERSION_INFO = window?.['__env']?.['version'];
export const TOPOLOGY = window?.['__env']?.['topologyUrl'];
export const EDGEURL = window?.['__env']?.['edgeUrl'];
export const EDGEAPIURL = window?.['__env']?.['edgeApiUrl'];
export const PCIAPIURL = window?.['__env']?.['pciApiUrl'];
export const FILESERVERURL=window?.['__env']?.['filesUrl'];
export const LOGFILESERVERURL=window?.['__env']?.['logFilesUrl'];
export const RULESENGINEURL=window?.['__env']?.['rulesEngineUrl'];
export const GOOGLEAPI = window?.['__env']?.['googleMapApi'];
export const MLSERVERURL = window?.['__env']?.['mlServerUrl'];
export const DIAGNOSTICURL = window?.['__env']?.['diagnosticUrl'];
export const IPERFURL = window?.['__env']?.['iperfUrl'];
export const UPGRADE_URL = window?.['__env']?.['upgradeUrl'];
export const userGuideFileName = window?.['__env']?.['userGuideFileName'];
export const gpsUrl = window?.['__env']?.['gpsApiUrl'];
export const leaflet = window?.['__env']?.['leaflet'];
export const chatbotUrl = window?.['__env']?.['chatbotUrl'];
export const tileServer = window?.['__env']?.['tileServer'];


